import { Injectable } from '@angular/core';
import {
  AtlasBounds,
  AtlasIconOptions,
  AtlasIcon,
  AtlasMarkerOptions,
  AtlasPosition,
  AtlasLabelOptions,
  AtlasLabel,
  AtlasPolygonOptions,
  AtlasPopupOptions,
  AtlasPopup,
} from '../interfaces/mu-atlas-types.interface';
import { AtlasFactory } from '../interfaces/mu-atlas-factory.interface';
import { AtlasPolygon } from '../interfaces/mu-atlas-polygon.interface';

@Injectable({
  providedIn: 'root',
})
export class MuMapAtlasService {
  private factory: AtlasFactory;

  setFactory(factory: AtlasFactory): void {
    this.factory = factory;
  }

  createBounds(position?: AtlasPosition): AtlasBounds {
    return this.factory.createBoundsInstance(position);
  }

  createMarker(options: AtlasMarkerOptions) {
    return this.factory.createMarkerInstance(options);
  }

  createIcon(options: AtlasIconOptions): AtlasIcon {
    return this.factory.createIconInstance(options);
  }

  createLabel(options: AtlasLabelOptions): AtlasLabel {
    return this.factory.createLabelInstance(options);
  }

  createPopup(options: AtlasPopupOptions): AtlasPopup {
    return this.factory.createPopupInstance(options);
  }
  createPolygon(options: AtlasPolygonOptions): AtlasPolygon {
    return this.factory.createPolygonInstance(options);
  }
}
